import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import * as fromStore from '../store';
import { Store } from '@ngrx/store';
import * as BookedTripActions from '../store/actions/booked-trip.actions';
import * as BookingStepActions from '../store/actions/booking-steps.actions';
import { BookingStep } from '@ibe/models/ui';
import * as _ from 'lodash';
import { TRIP_TYPE_ROUND_TRIP_CODE, TRIP_TYPE_ONE_WAY_CODE, TRIP_TYPE_MULTICITY_CODE, BRAND_CODE_DISCOUNT, BRAND_CODE_CLASSIC, BRAND_CODE_PLUS, BRAND_CODE_EXECUTIVE, BRAND_CODE_BASIC, BRAND_CODE_TOP_EXECUTIVE, MOCK_URL_BEST_OFFERS, URL_BEST_OFFERS, MOCK_STATUS, EQUIPMENT_CODE_TRAIN, EQUIPMENT_CODE_BUS, AIRPLANE_EQUIPMENT_CODE_32N, AIRPLANE_EQUIPMENT_CODE_32Q, AIRPLANE_EQUIPMENT_CODE_339, URL_BFM_BOOKING_FLIGHTS_INFO, MOCK_URL_FLIGHT_INFO, BRAND_CODE_AWARD_ECONOMY, BRAND_CODE_AWARD_EXECUTIVE, BRAND_CODE_STAR_ALLIANCE_ECONOMY, BRAND_CODE_STAR_ALLIANCE_BUSINESS, MOCK_URL_BOOKING_FARE, URL_BOOKING_FARE, URL_BFM_BOOKING_CREATE, URL_BFM_BOOKING_ISSUE, AIRLINE_TAP_CODE, TP_EXPRESS_PORTUGALIA, TP_EXPRESS_WHITE_AIRWAYS, URL_GENERATE_PNR, MOCK_URL_BFM_GENERATE_PNR, URL_TIME_TO_THINK, MOCL_URL_TIME_TO_THINK, TAP_MILES_AND_GO_FF_TIER_LEVELS_ALT, URL_WEAKFLIGHT_INFO, MOCK_URL_WEAKFLIGHT_INFO, URL_BFM_BOOKING_FARE_BREAKDOWN, MOCK_URL_FARE_TAXES_BREAKDOWN, URL_BLOCK_TAP_EXPERIENCE, MOCK_URL_INFORMATION_ECONOMY, URL_BFM_BOOKING_INFORMATION_MILES, MOCK_URL_FARE_INFORMATION_MILES, AIRPLANE_AIRBUS_EQUIPMENTS, CODE_SHARE_INTERLINE_FLIGHT_OPERATION_CARRIER, AIRLINE_CODES, TP_EXPRESS_LOGO, FLIGHT_HAUL_TYPE_LONG, URL_BUS_STOPS_AVAILABILITY, MOCK_URL_BUS_STOPS, BRAND_CODE_STAR_ALLIANCE_FIRST, MOCK_URL_DUPLICATE_BOOKING, MOCK_URL_BFM_GENERATE_PNR_VIEW, MOCK_URL_BFM_GENERATE_TTT_PNR_FOR_COMPLETION, URL_ROOT, MOCK_URL_FARE_BREAKDOWN_VIEW, COUNTRY_CODE_PORTUGAL, AWARD_FLOW_MARKETS, AWARD_FLOW_MARKET_CURRENCY_MAP, TAP_HEADER_MILES_AND_GO_GOLD, TAP_HEADER_MILES_AND_GO_NAVIGATOR, TAP_HEADER_MILES_AND_GO_MILES, TAP_HEADER_MILES_AND_GO_SILVER, MOCK_URL_AVAILABILITY_BOOKING_SELECT, URL_BFM_BOOKING_AVAILABILITY_SELECT } from '@ibe.config';
import { INDRADateService } from './date.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAApiService } from '@ibe/services';
import { Flight, BookedTrip } from '@ibe/models';
import { INDRABFMBestOffersResponse } from '@ibe.models/best-offers.indra.model';
import { INDRAStorageService } from './storage.indra.service';
import { INDRABookingService } from './booking.indra.service';
import { INDRAParallelService } from './parallel.indra.service';
import { finalize } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@ngrx/store";
import * as i3 from "./date.indra.service";
import * as i4 from "./bfm-data-storage.indra.service";
import * as i5 from "./ibeadmin.indra.service";
import * as i6 from "./api.indra.service";
import * as i7 from "./booking.indra.service";
import * as i8 from "./storage.indra.service";
import * as i9 from "./parallel.indra.service";
var INDRABookingSearchService = /** @class */ (function () {
    function INDRABookingSearchService(http, store, dateService, dataStorage, ibeAdminService, api, _http, bookingService, storageService, parallelService) {
        var _this = this;
        this.http = http;
        this.store = store;
        this.dateService = dateService;
        this.dataStorage = dataStorage;
        this.ibeAdminService = ibeAdminService;
        this.api = api;
        this._http = _http;
        this.bookingService = bookingService;
        this.storageService = storageService;
        this.parallelService = parallelService;
        // Flight booking steps
        this.booking_steps$ = this.store.select(fromStore.getSelectedBookingSteps);
        this.current_step$ = this.store.select(fromStore.getSelectedBookingCurrentStep);
        this.booking_type$ = this.store.select(fromStore.getSelectedBookingType);
        // Active Booking Trip
        this.booking_trip$ = this.store.select(fromStore.getSelectedBookedTrip);
        this.flightFilter$ = this.store.select(fromStore.getFlightsFilterState);
        this._triggerPNRFareBreakdown = new BehaviorSubject(false);
        this.triggerPNRFareBreakdown$ = this._triggerPNRFareBreakdown.asObservable();
        this.pendingFlight = new Subject();
        this.multiFlights = new Subject();
        this.paymentStatus = new Subject();
        this._current_step = 0;
        this.booking_steps$.subscribe(function (value) { return _this._steps = value; });
        this.current_step$.subscribe(function (value) { return _this._current_step = value; });
        this.booking_trip$.subscribe(function (value) { return _this._booking_trip = value; });
        this.booking_type$.subscribe(function (value) { return _this._booking_type = value; });
        this.flightFilter$.subscribe(function (value) { return _this.flightFilter = value; });
    }
    /************ API calls (NOTE: put API calls here) ******************/
    INDRABookingSearchService.prototype.INDRA_getBestOffers = function (marketCode, languageCode, airportCode) {
        if (MOCK_STATUS.BEST_OFFERS) {
            return this.api.INDRA_get(MOCK_URL_BEST_OFFERS);
        }
        else {
            return this.api.INDRA_get(URL_BEST_OFFERS + "?entityId=1&marketCode=" + marketCode + "&languageCode=" + languageCode + "&airportCodeFrom=" + airportCode + "&destinationDealsMax=15");
        }
    };
    INDRABookingSearchService.prototype.INDRA_getJourneys = function () {
        if (MOCK_STATUS.BEST_OFFERS) {
            return this.api.INDRA_get(MOCK_URL_BEST_OFFERS);
        }
        else {
            return this.api.INDRA_get(URL_BEST_OFFERS + "?entityId=1&marketCode=PT&languageCode=en&airportCodeFrom=LIS&destinationDealsMax=15");
        }
    };
    INDRABookingSearchService.prototype.INDRA_createBooking = function () {
        if (MOCK_STATUS.CREATE_BOOKING) {
            // return this.api.INDRA_get<any>(MOCK_URL_BOOKING_ANCILLARIES_ERROR);
            return this.api.INDRA_get(MOCK_URL_DUPLICATE_BOOKING);
        }
        else {
            return this.api.INDRA_post(URL_BFM_BOOKING_CREATE, null);
        }
    };
    INDRABookingSearchService.prototype.INDRA_issueBooking = function () {
        return this.api.INDRA_post(URL_BFM_BOOKING_ISSUE, null);
    };
    INDRABookingSearchService.prototype.INDRA_getFlightsInfo = function (params) {
        if (MOCK_STATUS.FLIGHT_INFO) {
            return this.http.get(MOCK_URL_FLIGHT_INFO);
        }
        else {
            return this.api.INDRA_post(URL_BFM_BOOKING_FLIGHTS_INFO, params);
        }
    };
    INDRABookingSearchService.prototype.INDRA_postBookingFare = function (params) {
        if (MOCK_STATUS.BOOKING_FARE) {
            return this.http.get(MOCK_URL_BOOKING_FARE);
        }
        else {
            this.bookingFarePost = this.api.INDRA_post(URL_BOOKING_FARE, params);
            return this.bookingFarePost;
        }
    };
    INDRABookingSearchService.prototype.INDRA_generateTemporaryPNR = function () {
        var _this = this;
        if (MOCK_STATUS.BOOKING_GENERATE_PNR) {
            return this.http.get(MOCK_URL_BFM_GENERATE_PNR);
        }
        else {
            this.parallelService.INDRA_setIsGenerateApiLoading(true);
            return this.api.INDRA_post(URL_GENERATE_PNR, {})
                .pipe(finalize(function () { return _this.parallelService.INDRA_setIsGenerateApiLoading(false); }));
        }
    };
    INDRABookingSearchService.prototype.INDRA_getPNRDetails = function () {
        var _this = this;
        if (MOCK_STATUS.BOOKING_GENERATE_PNR_VIEW) {
            return this.http.get(MOCK_URL_BFM_GENERATE_PNR_VIEW);
        }
        else {
            this.parallelService.INDRA_setIsGenerateApiLoading(true);
            return this.api.INDRA_post(URL_GENERATE_PNR, {})
                .pipe(finalize(function () { return _this.parallelService.INDRA_setIsGenerateApiLoading(false); }));
        }
    };
    INDRABookingSearchService.prototype.INDRA_getPNRDetailsForTTTCompletion = function (documentNumber, lastname) {
        if (MOCK_STATUS.BOOKING_GENERATE_TTT_PNR_FOR_COMPLETION) {
            return this.http.get(MOCK_URL_BFM_GENERATE_TTT_PNR_FOR_COMPLETION);
        }
        else {
            var data = {
                "surname": lastname,
                "timeToThink": true
            };
            if (documentNumber.length === 6) {
                data['pnrNumber'] = documentNumber;
            }
            else {
                data['ticketNumber'] = documentNumber;
            }
            return this.api.INDRA_post(URL_GENERATE_PNR, data);
        }
    };
    INDRABookingSearchService.prototype.INDRA_getPNRFareBreakdown = function (pnr) {
        if (MOCK_STATUS.BOOKING_FARE_BREAKDOWN_VIEW) {
            return this.http.get(MOCK_URL_FARE_BREAKDOWN_VIEW);
        }
        else {
            var URL_1 = URL_ROOT + "booking/pnrs/" + pnr + "/fares/breakdown";
            var response = this.api.INDRA_get(URL_1);
            return response;
        }
    };
    INDRABookingSearchService.prototype.INDRA_getBlockTAPExperience = function (request) {
        if (MOCK_STATUS.INFORMATION_ECONOMY) {
            return this.http.get(MOCK_URL_INFORMATION_ECONOMY);
        }
        else {
            return this.api.INDRA_post(URL_BLOCK_TAP_EXPERIENCE, request);
        }
    };
    INDRABookingSearchService.prototype.INDRA_getFareAndTaxesBreakdown = function (param) {
        if (MOCK_STATUS.FARE_TAXES_BREAKDOWN) {
            return this.http.get(MOCK_URL_FARE_TAXES_BREAKDOWN);
        }
        else {
            return this.api.INDRA_post(URL_BFM_BOOKING_FARE_BREAKDOWN, param);
        }
    };
    INDRABookingSearchService.prototype.INDRA_getInformationMiles = function (param) {
        if (MOCK_STATUS.FARE_INFORMATION_MILES) {
            return this.http.get(MOCK_URL_FARE_INFORMATION_MILES);
        }
        else {
            return this.api.INDRA_post(URL_BFM_BOOKING_INFORMATION_MILES, param);
        }
    };
    INDRABookingSearchService.prototype.INDRA_getTimeToThink = function (params) {
        if (MOCK_STATUS.TIME_TO_THINK) {
            return this.http.get(MOCL_URL_TIME_TO_THINK);
        }
        else {
            var timeToThink = this.api.INDRA_post(URL_TIME_TO_THINK, params);
            return timeToThink;
        }
    };
    INDRABookingSearchService.prototype.INDRA_getInformationWeakFlights = function (weakFlight) {
        if (MOCK_STATUS.WEAK_FLIGHT_INFO) {
            return this.http.get(MOCK_URL_WEAKFLIGHT_INFO);
        }
        else {
            return this.api.INDRA_post(URL_WEAKFLIGHT_INFO, weakFlight);
        }
    };
    INDRABookingSearchService.prototype.INDRA_getAvailableBusStops = function (param) {
        if (MOCK_STATUS.BUS_STOPS) {
            return this.http.get(MOCK_URL_BUS_STOPS);
        }
        else {
            return this.api.INDRA_get(URL_BUS_STOPS_AVAILABILITY + "origin=" + param.origin + "&destination=" + param.destination);
        }
    };
    INDRABookingSearchService.prototype.INDRA_selectBookingAvailability = function (param) {
        if (MOCK_STATUS.BOOKING_AVAILABILITY_SEARCH) {
            var mockURL = MOCK_URL_AVAILABILITY_BOOKING_SELECT;
            return this.http.get(mockURL);
        }
        else {
            return this.api.INDRA_post(URL_BFM_BOOKING_AVAILABILITY_SELECT + "?payWithMiles=false&starAlliance=false", param);
        }
    };
    /************************* API calls end *************************/
    /**
     * Get booking type text formated
     * @param {String} booking_type to return
     * @returns booking type text
     */
    INDRABookingSearchService.prototype.INDRA_getBookingType = function (booking_type) {
        switch (booking_type) {
            case TRIP_TYPE_ROUND_TRIP_CODE:
                return 'Round trip';
            case TRIP_TYPE_ONE_WAY_CODE:
                return 'One way';
            case TRIP_TYPE_MULTICITY_CODE:
                return 'Multicity';
            default:
                return;
        }
    };
    /**
     * Convert amadeus brand code into TAP brand codes
     * @param {String} fareFamily (amadeus brand codes)
     * @returns TAP brand codes
     */
    INDRABookingSearchService.prototype.INDRA_getBrandCodeFromAmadeus = function (fareFamily) {
        if (fareFamily.substring(0, 2) == 'AW') {
            if (fareFamily.includes('BAS') || fareFamily.includes('CLA')) {
                if (this.flightFilter) {
                    return this.flightFilter.starAlliance ? BRAND_CODE_STAR_ALLIANCE_ECONOMY : BRAND_CODE_AWARD_ECONOMY;
                }
                else {
                    return BRAND_CODE_AWARD_ECONOMY;
                }
            }
            else if (fareFamily.includes('EXE')) {
                if (this.flightFilter) {
                    return this.flightFilter.starAlliance ? BRAND_CODE_STAR_ALLIANCE_BUSINESS : BRAND_CODE_AWARD_EXECUTIVE;
                }
                else {
                    return BRAND_CODE_AWARD_EXECUTIVE;
                }
            }
            else if (fareFamily.includes('FIRST')) {
                return BRAND_CODE_STAR_ALLIANCE_FIRST;
            }
        }
        else {
            if (fareFamily.includes('DIS')) {
                return BRAND_CODE_DISCOUNT;
            }
            else if (fareFamily.includes('BAS')) {
                return BRAND_CODE_BASIC;
            }
            else if (fareFamily.includes('CLA')) {
                return BRAND_CODE_CLASSIC;
            }
            else if (fareFamily.includes('PLU')) {
                return BRAND_CODE_PLUS;
            }
            else if (fareFamily.includes('EXE')) {
                return BRAND_CODE_EXECUTIVE;
            }
            else if (fareFamily.includes('TOP')) {
                return BRAND_CODE_TOP_EXECUTIVE;
            }
            else {
                return '';
            }
        }
    };
    INDRABookingSearchService.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    /** Gets the last segment with equipment unequal to TRN */
    INDRABookingSearchService.prototype.INDRA_getLastSegmentFlightIgnoringTrain = function (listSegment) {
        var returnVal;
        listSegment.forEach(function (segment) {
            if (segment.equipment !== EQUIPMENT_CODE_TRAIN) {
                returnVal = segment;
            }
        });
        return returnVal;
    };
    /** Gets the first segment with equipment unequal to TRN */
    INDRABookingSearchService.prototype.INDRA_getFirstSegmentFlightIgnoringTrain = function (listSegment) {
        return listSegment.filter(function (segment) {
            return segment.equipment !== EQUIPMENT_CODE_TRAIN;
        })[0];
    };
    INDRABookingSearchService.prototype.INDRA_hasNonAirplaneSegment = function (flights, nonAirplaneEquipmentType) {
        var hasNonAirplaneEquipmentInTrip = false;
        var nonAirplaneEquipments = [EQUIPMENT_CODE_TRAIN, EQUIPMENT_CODE_BUS];
        if (!nonAirplaneEquipments.includes(nonAirplaneEquipmentType)) {
            return hasNonAirplaneEquipmentInTrip;
        }
        flights.forEach(function (flight) {
            flight['listSegment'].filter(function (segment) {
                if (segment.equipment == nonAirplaneEquipmentType) {
                    hasNonAirplaneEquipmentInTrip = true;
                }
            });
        });
        return hasNonAirplaneEquipmentInTrip;
    };
    INDRABookingSearchService.prototype.INDRA_getNEOEquipmentLogoName = function (equipment, haulType) {
        switch (equipment) {
            case AIRPLANE_EQUIPMENT_CODE_32N:
                return 'airplane--a320neo';
            case AIRPLANE_EQUIPMENT_CODE_32Q:
                return haulType && haulType === FLIGHT_HAUL_TYPE_LONG ? 'airplane--a321LRneo' : 'airplane--a321neo';
            case AIRPLANE_EQUIPMENT_CODE_339:
                return 'airplane--a330neo';
            default:
                return;
        }
    };
    /** check if thr flight has any NEO plane model on any of its airplanes */
    INDRABookingSearchService.prototype.INDRA_hasNEOPlaneModel = function (flight) {
        if (flight.listSegment && flight.listSegment.length > 0) {
            var equipmentsWithNEO = flight.listSegment.filter(function (segment) { return segment.equipment === AIRPLANE_EQUIPMENT_CODE_32N ||
                segment.equipment === AIRPLANE_EQUIPMENT_CODE_32Q ||
                segment.equipment === AIRPLANE_EQUIPMENT_CODE_339; });
            return (equipmentsWithNEO.length > 0);
        }
        return false;
    };
    /** check if a given flight is a codeshare (has any segment operated by non-TAP airlines) **/
    INDRABookingSearchService.prototype.INDRA_isCodeShareFlight = function (flight) {
        var tapAirlineCodes = [AIRLINE_TAP_CODE, TP_EXPRESS_PORTUGALIA, TP_EXPRESS_WHITE_AIRWAYS];
        var codeShare = flight.listSegment.find(function (segment) { return (!tapAirlineCodes.includes(segment.operationCarrier)); });
        if (codeShare) {
            return true;
        }
        return false;
    };
    /** Checks all destination in the search route if there is at least one ineligible for award flight booking **/
    INDRABookingSearchService.prototype.INDRA_getRouteAwardEligibility = function (searchRoute) {
        // only return false if at least one destination is both false in tapRoute and starAllianceRoute
        // no need to check origin since the flags to be considered are in the destination
        var hasEligibleRoute = true;
        if (searchRoute) {
            searchRoute.map(function (currentSearchRoute) {
                if (currentSearchRoute && currentSearchRoute['arrival']) {
                    if (currentSearchRoute['arrival']['tapRoute'] === false &&
                        currentSearchRoute['arrival']['starAllianceRoute'] === false) {
                        hasEligibleRoute = false;
                    }
                }
            });
        }
        return hasEligibleRoute;
    };
    /** Checks all destination in the search route if there is at least one ineligible for commercial flight booking **/
    INDRABookingSearchService.prototype.INDRA_getRouteCommercialEligibility = function (searchRoute) {
        // only return false if at least one destination is fale in CommercialRoute
        // no need to check origin since the flags to be considered are in the destination
        var hasEligibleRoute = true;
        if (searchRoute) {
            searchRoute.map(function (currentSearchRoute) {
                if (currentSearchRoute && currentSearchRoute['arrival']) {
                    if (currentSearchRoute['arrival']['commercialRoute'] === false) {
                        hasEligibleRoute = false;
                    }
                }
            });
        }
        return hasEligibleRoute;
    };
    /** Checks if specific Airport is eligible for award booking **/
    INDRABookingSearchService.prototype.INDRA_getAirportAwardBookingEligibility = function (airport) {
        var isAirportEligibleForAwardRoute = false;
        if (airport && (airport['tapRoute'] === true || airport['starAllianceRoute'] === true)) {
            isAirportEligibleForAwardRoute = true;
        }
        return isAirportEligibleForAwardRoute;
    };
    /** Checks if specific Airport is eligible for commercial booking **/
    INDRABookingSearchService.prototype.INDRA_getAirportCommercialBookingEligbility = function (airport) {
        var isAirportEligibleForCommercialRoute = false;
        if (airport && airport['commercialRoute'] === true) {
            isAirportEligibleForCommercialRoute = true;
        }
        return isAirportEligibleForCommercialRoute;
    };
    /**
     * Sets the flight and flight date for the indicated index
     * @param flight Flight object to add to this._flights
     * @param index Flight index. If null, will use current_step
     * @param time Time of the flight. Should be sent explicitly
     * in case flight object changes.
     */
    INDRABookingSearchService.prototype.setFlight = function (flight, time, index) {
        if (index === void 0) { index = this._current_step; }
        var neue_flight = Object.assign(new Flight(flight.departure, flight.arrival, flight.number), flight);
        if (flight.stopover)
            neue_flight.setStopover(flight.stopover);
        var flights = this._booking_trip.flights.map(function (cur) { return Object.assign(new Flight(null, null, null), cur); });
        flights[index] = neue_flight;
        var newBookedTrip = Object.assign(new BookedTrip(null, null, null), this._booking_trip, { flights: flights });
        this.store.dispatch(new BookedTripActions.PutBookedTripAction(newBookedTrip));
        this.updateStepFlight(time, index);
        this.goToNextStep();
    };
    /*
    *
    */
    INDRABookingSearchService.prototype.updateFooterData = function (stage, payload) {
        if (stage === 'flights') {
            this.pendingFlight.next({ flt: payload.flight, time: payload.time });
        }
        if (stage === 'multicity') {
            this.multiFlights.next({ flts: payload.flights });
        }
    };
    /**
     * Checks if all dates have been selected for the ongoing booking
     * @returns {boolean}
     */
    INDRABookingSearchService.prototype.allDatesSelected = function () {
        for (var i = 0; i < this._steps.length; i++) {
            if (!this._steps[i].date_selected) {
                return false;
            }
        }
        return true;
    };
    /** Called when a step is complete */
    INDRABookingSearchService.prototype.updateStepFlight = function (time, index) {
        var steps = this._steps.map(function (cur) { return Object.assign(new BookingStep(null, null), cur); }).slice();
        steps[index].flight_selected = true;
        steps[index].date = time;
        this.store.dispatch(new BookingStepActions.PutStepsAction(steps));
    };
    /** Called when a step is complete */
    INDRABookingSearchService.prototype.goToNextStep = function () {
        if (this._current_step === null) {
            this._current_step = 0;
            this.store.dispatch(new BookingStepActions.PutCurrentStepAction(this._current_step));
        }
        if (!this.isLastStep(this._current_step)) {
            this._current_step++;
            this.store.dispatch(new BookingStepActions.PutCurrentStepAction(this._current_step));
        }
    };
    INDRABookingSearchService.prototype.isLastStep = function (index) {
        if (!index)
            index = this._current_step;
        return index === this._steps.length - 1;
    };
    INDRABookingSearchService.prototype.INDRA_getFlightSegmentsCountryList = function (segmentList) {
        var _this = this;
        var countries = [];
        if (segmentList && segmentList.length > 0) {
            segmentList.forEach(function (segment) {
                var departureCountryCode = _this.dataStorage.INDRA_getBookingAvailability().translate.locations[segment.departureAirport].countryCode;
                var arrivalCountryCode = _this.dataStorage.INDRA_getBookingAvailability().translate.locations[segment.arrivalAirport].countryCode;
                if (countries.filter(function (country) { return country !== departureCountryCode; }))
                    countries.push(departureCountryCode);
                if (countries.filter(function (country) { return country !== arrivalCountryCode; }))
                    countries.push(arrivalCountryCode);
            });
        }
        return countries;
    };
    INDRABookingSearchService.prototype.INDRA_filterBestOffers = function (brandList, type, bookAwardFlight, isStarAlliance) {
        var returnValue = [];
        // this will fetch the best offers for each brand (ignores same brand offers that has higher price)..
        if (!bookAwardFlight) {
            if (type == 'economy') {
                var discountList = this.INDRA_fetchBestItemForBrand(brandList.filter(function (brand) { return brand.name == BRAND_CODE_DISCOUNT; }));
                var classicList = this.INDRA_fetchBestItemForBrand(brandList.filter(function (brand) { return brand.name == BRAND_CODE_CLASSIC; }));
                var basicList = this.INDRA_fetchBestItemForBrand(brandList.filter(function (brand) { return brand.name == BRAND_CODE_BASIC; }));
                var plusList = this.INDRA_fetchBestItemForBrand(brandList.filter(function (brand) { return brand.name == BRAND_CODE_PLUS; }));
                returnValue = discountList.concat(classicList, basicList, plusList);
            }
            else {
                var exeList = this.INDRA_fetchBestItemForBrand(brandList.filter(function (brand) { return brand.name == BRAND_CODE_EXECUTIVE; }));
                var topList = this.INDRA_fetchBestItemForBrand(brandList.filter(function (brand) { return brand.name == BRAND_CODE_TOP_EXECUTIVE; }));
                returnValue = exeList.concat(topList);
            }
        }
        else {
            if (isStarAlliance) {
                if (type == 'economy') {
                    var economyList = this.INDRA_fetchBestItemForBrand(brandList.filter(function (brand) { return brand.name == BRAND_CODE_STAR_ALLIANCE_ECONOMY; }));
                    returnValue = economyList;
                }
                else if (type == 'business') {
                    var executiveList = this.INDRA_fetchBestItemForBrand(brandList.filter(function (brand) { return brand.name == BRAND_CODE_STAR_ALLIANCE_BUSINESS; }));
                    returnValue = executiveList;
                }
                else {
                    var firstClassList = this.INDRA_fetchBestItemForBrand(brandList.filter(function (brand) { return brand.name == BRAND_CODE_STAR_ALLIANCE_FIRST; }));
                    returnValue = firstClassList;
                }
            }
            else {
                if (type == 'economy') {
                    var economyList = this.INDRA_fetchBestItemForBrand(brandList.filter(function (brand) { return brand.name == BRAND_CODE_AWARD_ECONOMY; }));
                    returnValue = economyList;
                }
                else {
                    var executiveList = this.INDRA_fetchBestItemForBrand(brandList.filter(function (brand) { return brand.name == BRAND_CODE_AWARD_EXECUTIVE; }));
                    returnValue = executiveList;
                }
            }
        }
        return returnValue;
    };
    INDRABookingSearchService.prototype.INDRA_fetchBestItemForBrand = function (brandItems) {
        if (brandItems.length == 0) {
            return [];
        }
        var list = brandItems.sort(function (currentItem, nextItem) {
            return currentItem.price - nextItem.price;
        });
        if (list.length > 1) {
            list.length = 1;
        }
        return list;
    };
    /**
     * Returns corresponding Location from stored availability response object if it exists
     * @param {string} code of location
     */
    INDRABookingSearchService.prototype.INDRA_getFlightSearchLocation = function (code) {
        var returnObject = {
            code: '',
            name: '',
            city: '',
            country: '',
            countryCode: ''
        };
        if (this.dataStorage.INDRA_getBookingAvailability() && this.dataStorage.INDRA_getBookingAvailability().translate.locations[code]) {
            return this.dataStorage.INDRA_getBookingAvailability().translate.locations[code];
        }
        return returnObject;
    };
    /**
     * Returns corresponding Airplane if it exists
     * @param {string} code of airplane
     */
    INDRABookingSearchService.prototype.INDRA_getFlightSearchAirplaneInfo = function (code) {
        var returnObject = {
            code: '',
            name: ''
        };
        if (this.dataStorage.INDRA_getBookingAvailability() && this.dataStorage.INDRA_getBookingAvailability().translate.airlines[code]) {
            returnObject = this.dataStorage.INDRA_getBookingAvailability().translate.airlines[code];
        }
        return returnObject;
    };
    /**
     * Returns true if the current user is a TAP Frequent Flyer program member
     * @param {user} user data
     */
    INDRABookingSearchService.prototype.INDRA_isFrequentFlyerMember = function (user) {
        if (user && user.ffLevel && TAP_MILES_AND_GO_FF_TIER_LEVELS_ALT.includes(user.ffLevel)) {
            return true;
        }
        return false;
    };
    /**
     * Returns true if the airline equipment is an airbus, otherwise returns false
     * @param {equipment} equipment model identifier/code
     */
    INDRABookingSearchService.prototype.INDRA_isAirbusModel = function (equipment) {
        return AIRPLANE_AIRBUS_EQUIPMENTS.includes(equipment) ? true : false;
    };
    /**
     * Gets the most significant TAP segment (longest duration). Returns NULL if
     * the most significant segment is not operated by TAP, returns NULL
     * @param {flight} flight data
     */
    INDRABookingSearchService.prototype.INDRA_getTAPMostSignificantFlightSegment = function (flight) {
        var listSegments = flight.listSegment.filter(function (segment) { return CODE_SHARE_INTERLINE_FLIGHT_OPERATION_CARRIER.includes(segment.operationCarrier); });
        if (listSegments.length === 0)
            return null;
        var mostSignificantFlightSegment = _.maxBy(flight.listSegment, (function (segment) { return segment.duration; }));
        return (CODE_SHARE_INTERLINE_FLIGHT_OPERATION_CARRIER.includes(mostSignificantFlightSegment.operationCarrier))
            ? mostSignificantFlightSegment : null;
    };
    INDRABookingSearchService.prototype.INDRA_getBookedFlightWithSegmentsOperatedByInterlineFlightsOnly = function (flight) {
        var listSegments = flight.listSegment.filter(function (segment) { return CODE_SHARE_INTERLINE_FLIGHT_OPERATION_CARRIER.includes(segment.operationCarrier); });
        if (listSegments.length === 0)
            return null;
        return listSegments;
    };
    /**
     * Returns the SVG logo name to be used for the given carrier code. Returns the TAP logo
     * when TAP and its ubsidiary airlines are provided, and returns not found logo when the
     * given carrier is not configured with an actual logo (uses AIRLINE_CODES in app.config-settings.
     * @param {carrier} carrier code
     */
    INDRABookingSearchService.prototype.INDRA_buildAirlineLogoName = function (carrier) {
        return 'sprite.svg#airlines--' +
            (TP_EXPRESS_LOGO.includes(carrier) ? 'TP_express' : (AIRLINE_CODES.includes(carrier) || carrier === 'Multiple' ? carrier : 'not_found'));
    };
    INDRABookingSearchService.prototype.INDRA_hasStopover = function (booked_trip) {
        var stopOverFoundFlag = false;
        var outbounds = booked_trip.data.fare.listOutbound;
        var outboundLength = booked_trip.data.fare.listOutbound.length;
        for (var i = 0; i < outboundLength; i++) {
            if (outbounds[i].isStopOver || outbounds[i].listSegment.some(function (segment) { return segment.stopover; })) {
                stopOverFoundFlag = true;
                break;
            }
        }
        // check stopover on inbound flights
        if (!stopOverFoundFlag && booked_trip.data.fare.listInbound) {
            var inbounds = booked_trip.data.fare.listInbound;
            var inboundLength = booked_trip.data.fare.listInbound.length;
            for (var i = 0; i < inboundLength; i++) {
                if (inbounds[i].isStopOver || inbounds[i].listSegment.some(function (segment) { return segment.stopover; })) {
                    stopOverFoundFlag = true;
                    break;
                }
            }
        }
        return stopOverFoundFlag;
    };
    INDRABookingSearchService.prototype.INDRA_removePNRInformationInSession = function () {
        this.dataStorage.INDRA_setActiveBookedTrip(null);
        this.dataStorage.INDRA_setOriginalPNRDetailsResponse(null);
        this.dataStorage.INDRA_setFlightTickets(null);
        this.dataStorage.INDRA_setThirdPartyAncillaries(null);
        this.dataStorage.INDRA_setAncillariesPerFlight(null);
    };
    INDRABookingSearchService.prototype.INDRA_getAirportByCityCode = function () {
        var URL = './assets/data/city.code.indra.json';
        var airportsList = this._http.get(URL);
        return airportsList;
    };
    /**
     * Returns object that tags all added ancillaries of passenger on the flight's first segment
     * @param {string} paramCode of ancillary group
     * @param {string} flightId
     */
    INDRABookingSearchService.prototype.INDRA_getAddedFeaturesOfFlightCardFirstSegment = function (paramCode, flightId, flightCardId, paxId) {
        var firstSegmentId = this.bookingService.INDRA_getFirstSegmentByFlightCard(flightCardId);
        var group = this.bookingService.INDRA_getSSRAvailableForGroup(paramCode);
        var addedFeatureCountArray = [];
        var ancillaryList = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
        if (!ancillaryList || !ancillaryList.itemsAdded.length) {
            return addedFeatureCountArray;
        }
        ancillaryList.itemsAdded.forEach(function (ancillary) {
            if (group.includes(ancillary.code) && ancillary.flightId == flightId && ancillary.segmentId == firstSegmentId && ancillary.paxId == paxId) {
                var addedFeatureIndex = addedFeatureCountArray.findIndex(function (checkedBaggageItem) { return checkedBaggageItem.code === ancillary.code; });
                if (addedFeatureIndex === -1) {
                    addedFeatureCountArray.push({
                        code: ancillary.code,
                        count: 1,
                    });
                }
                else {
                    addedFeatureCountArray[addedFeatureIndex].count++;
                }
            }
        });
        return addedFeatureCountArray;
    };
    /**
     * Returns the correct award market given the user market.
     * Note that award markets are given by the constants array AWARD_FLOW_MARKETS.
     * @param {string} userMarket market from the user profile
     */
    INDRABookingSearchService.prototype.INDRA_getAwardBookingMarket = function (userMarket) {
        var awardMarket = COUNTRY_CODE_PORTUGAL;
        if (userMarket) {
            if (AWARD_FLOW_MARKETS.includes(userMarket)) {
                awardMarket = userMarket;
            }
        }
        return awardMarket;
    };
    INDRABookingSearchService.prototype.INDRA_getAwardBookingCurrency = function (awardMarket) {
        return AWARD_FLOW_MARKET_CURRENCY_MAP[awardMarket];
    };
    /**
     * Returns true if the user has enough miles balance to cover the flight miles cost,
     * otherwise returns false.
     * @param {number} totalFlightMilesCost cost of the flight/s
     * @param {number} userMilesBalance of the logged-in user (account miles balance)
     * @param {string} userTierLevel of the logged-in user
     */
    INDRABookingSearchService.prototype.INDRA_checkIfEnoughMilesForFlight = function (totalFlightMilesCost, userMilesBalance, userTierLevel) {
        var deficitMiles = Number(totalFlightMilesCost) - Number(userMilesBalance);
        var limitNegativeMiles;
        switch (userTierLevel) {
            case TAP_HEADER_MILES_AND_GO_MILES:
                limitNegativeMiles = 500;
                break;
            case TAP_HEADER_MILES_AND_GO_SILVER:
                limitNegativeMiles = 5000;
                break;
            case TAP_HEADER_MILES_AND_GO_GOLD:
                limitNegativeMiles = 10000;
                break;
            case TAP_HEADER_MILES_AND_GO_NAVIGATOR:
                limitNegativeMiles = 20000;
                break;
            default:
                limitNegativeMiles = 0;
                break;
        }
        if (deficitMiles > limitNegativeMiles) {
            return false;
        }
        else {
            return true;
        }
    };
    INDRABookingSearchService.prototype.INDRA_setTriggerPNRFareBreakdown = function (value) {
        this._triggerPNRFareBreakdown.next(value);
    };
    /**
     * Clear selected dates
     */
    INDRABookingSearchService.prototype.INDRA_clearDates = function () {
        var auxArray = [];
        this._steps.forEach(function (step) {
            auxArray.push(Object.assign(new BookingStep(null, null), step, {
                cost: null,
                date: null,
                date_selected: false
            }));
        });
        this.store.dispatch(new BookingStepActions.PutStepsAction(auxArray));
        this.store.dispatch(new BookingStepActions.PutCurrentStepAction(0));
    };
    INDRABookingSearchService.ngInjectableDef = i0.defineInjectable({ factory: function INDRABookingSearchService_Factory() { return new INDRABookingSearchService(i0.inject(i1.HttpClient), i0.inject(i2.Store), i0.inject(i3.INDRADateService), i0.inject(i4.INDRABFMDataStorageService), i0.inject(i5.INDRAIbeAdminService), i0.inject(i6.INDRAApiService), i0.inject(i1.HttpClient), i0.inject(i7.INDRABookingService), i0.inject(i8.INDRAStorageService), i0.inject(i9.INDRAParallelService)); }, token: INDRABookingSearchService, providedIn: "root" });
    return INDRABookingSearchService;
}());
export { INDRABookingSearchService };
